import React from 'react';
import _ from 'lodash';

import PropTypes from 'prop-types';

import Row from './Row';

const Table = ({ pageLayout, data, fetchOrders, totalOrders }) => {
  return (
    <div className="responsive-table-container">
      <table className="responsive-table">
        <caption className="responsive-table__caption">
          {`${_.get(pageLayout, 'tableTitle', '')} (${totalOrders})`}
        </caption>
        <thead className="responsive-table__thead">
          <tr>
            {_.get(pageLayout, 'tableHeaders', []).map(header => (
              <th key={_.get(header, 'sys.id', '')}>
                {_.get(header, 'fields.title', '')}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="responsive-table__tbody">
          {data &&
            data.map((order, index) => (
              <Row
                key={order.id}
                index={index}
                order={order}
                pageLayout={pageLayout}
                fetchOrders={fetchOrders}
                headers={_.get(pageLayout, 'tableHeaders', []).map(
                  item => item.fields.title
                )}
              />
            ))}
        </tbody>
      </table>
    </div>
  );
};

Table.propTypes = {
  pageLayout: PropTypes.objectOf(PropTypes.object).isRequired,
  data: PropTypes.objectOf(PropTypes.array).isRequired,
  fetchOrders: PropTypes.func.isRequired,
  totalOrders: PropTypes.number.isRequired
};

export default Table;
